module.exports = __webpack_public_path__ + "static/media/Bamazon.3ab8c721.png";